import useAsync from './useAsync';

export default useAsync;
